import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon, LockIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="w-full bg-[#0f1629] py-20 md:py-28" data-id="element-119">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-121">
          {/* Urgency Text */}
          <p className="text-[#d4a574] text-lg md:text-xl mb-6 font-['Playfair_Display'] italic" data-id="element-122">
            No dejes que una noche más de ansiedad te robe tu energía y tu
            belleza.
          </p>

          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl lg:text-5xl font-bold text-[#f0ebe3] mb-4" data-id="element-123">
            Recupera Tu Centro{' '}
            <span className="text-[#c9a96e]" data-id="element-124">Ahora Mismo</span>
          </h2>

          <p className="text-[#a0998e] text-lg mb-12" data-id="element-125">
            Por menos de lo que cuesta un café y un postre
          </p>

          {/* Price Card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gradient-to-b from-[#1a2342] to-[#1a2342]/80 border-2 border-[#c9a96e]/50 rounded-3xl p-8 md:p-12 max-w-lg mx-auto mb-12" data-id="element-126">
            <span className="inline-block text-[#c9a96e] text-sm font-semibold tracking-wider uppercase mb-4" data-id="element-127">
              Precio Especial de Lanzamiento
            </span>

            <div className="mb-6" data-id="element-128">
              <span className="text-[#a0998e] text-2xl md:text-3xl line-through mr-3 font-['Playfair_Display']" data-id="element-129">
                $12.00
              </span>
              <span className="text-[#c9a96e] text-6xl md:text-7xl font-bold font-['Playfair_Display']" data-id="element-130">
                $6.39
              </span>
              <span className="text-[#a0998e] text-2xl ml-2" data-id="element-131">USD</span>
            </div>

            <ul className="text-left space-y-3 mb-8" data-id="element-132">
              <li className="flex items-center gap-3 text-[#f0ebe3]/90" data-id="element-133">
                <ZapIcon className="w-5 h-5 text-[#c9a96e] flex-shrink-0" data-id="element-134" />
                <span data-id="element-135">Acceso instantáneo al PDF completo</span>
              </li>
              <li className="flex items-center gap-3 text-[#f0ebe3]/90" data-id="element-136">
                <ZapIcon className="w-5 h-5 text-[#c9a96e] flex-shrink-0" data-id="element-137" />
                <span data-id="element-138">Audio guía para las primeras 24 horas</span>
              </li>
              <li className="flex items-center gap-3 text-[#f0ebe3]/90" data-id="element-139">
                <ZapIcon className="w-5 h-5 text-[#c9a96e] flex-shrink-0" data-id="element-140" />
                <span data-id="element-141">Worksheets de realidad descargables</span>
              </li>
              <li className="flex items-center gap-3 text-[#f0ebe3]/90" data-id="element-142">
                <ZapIcon className="w-5 h-5 text-[#c9a96e] flex-shrink-0" data-id="element-143" />
                <span data-id="element-144">Guía de respuestas de emergencia</span>
              </li>
            </ul>

            <motion.a href="https://www.menteritual.com/cart/56784871948448:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-r from-[#c9a96e] to-[#d4a574] text-[#0f1629] font-bold px-8 py-5 rounded-xl text-xl text-center transition-all duration-300 hover:shadow-lg hover:shadow-[#c9a96e]/40" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-145">
              ¡SÁCAME DE ESTE BUCLE AHORA!
            </motion.a>

            <p className="text-[#a0998e] text-sm mt-4" data-id="element-146">
              Acceso instantáneo incluso si son las 3 de la mañana
            </p>
          </motion.div>

          {/* Trust Badges */}
          <div className="flex flex-wrap justify-center gap-6 md:gap-10" data-id="element-147">
            <div className="flex items-center gap-2 text-[#a0998e]" data-id="element-148">
              <LockIcon className="w-5 h-5 text-[#c9a96e]" data-id="element-149" />
              <span className="text-sm" data-id="element-150">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-2 text-[#a0998e]" data-id="element-151">
              <ShieldCheckIcon className="w-5 h-5 text-[#c9a96e]" data-id="element-152" />
              <span className="text-sm" data-id="element-153">Encriptación Bancaria</span>
            </div>
            <div className="flex items-center gap-2 text-[#a0998e]" data-id="element-154">
              <ZapIcon className="w-5 h-5 text-[#c9a96e]" data-id="element-155" />
              <span className="text-sm" data-id="element-156">Acceso Inmediato</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}